const screen = document.getElementById("cube");

if (screen) {
  const width = 82;
  const height = 32;
  const size = width * height;

  const buffer = new Array(size);
  const zBuffer = new Float32Array(size);

  const distanceFromCam = 100;
  const K1 = 40;
  const step = 0.6;

  let A = 0;
  let B = 0;
  let C = 0;

  function frame() {
    buffer.fill(" ");
    zBuffer.fill(0);

    const sinA = Math.sin(A);
    const cosA = Math.cos(A);
    const sinB = Math.sin(B);
    const cosB = Math.cos(B);
    const sinC = Math.sin(C);
    const cosC = Math.cos(C);

    function face(i, j, k, character) {
      const x =
        j * sinA * sinB * cosC -
        k * cosA * sinB * cosC +
        j * cosA * sinC +
        k * sinA * sinC +
        i * cosB * cosC;

      const y =
        j * cosA * cosC +
        k * sinA * cosC -
        j * sinA * sinB * sinC +
        k * cosA * sinB * sinC -
        i * cosB * sinC;

      const z =
        k * cosA * cosB -
        j * sinA * cosB +
        i * sinB +
        distanceFromCam;

      const ooz = 1 / z;
      const xp = (width / 2 + K1 * ooz * x * 1.55) | 0;
      const yp = (height / 2 + K1 * ooz * y) | 0;
      const index = xp + yp * width;

      if (index >= 0 && index < size && ooz > zBuffer[index]) {
        zBuffer[index] = ooz;
        buffer[index] = character;
      }
    }

    for (let cubeX = -20; cubeX < 20; cubeX += step) {
      for (let cubeY = -20; cubeY < 20; cubeY += step) {
        face(cubeX, cubeY, -20, "@");
        face(20, cubeY, cubeX, "$");
        face(-20, cubeY, -cubeX, "~");
        face(-cubeX, cubeY, 20, "#");
        face(cubeX, -20, -cubeY, ";");
        face(cubeX, 20, cubeY, "+");
      }
    }

    let output = "";

    for (let row = 0; row < height; row++) {
      output += buffer
        .slice(row * width, (row + 1) * width)
        .join("") + "\n";
    }

    screen.textContent = output;

    A += 0.028;
    B += 0.034;
    C += 0.009;

    setTimeout(() => requestAnimationFrame(frame), 16);
  }

  frame();
}
